import { Timestamp } from "firebase/firestore";
import { Class } from "../classe/classe.type";
import { Subscription } from "../subscription/subscription.type";
import { ObjectifStudent } from "../objectifStudent/objectifStudent.type";
import { DevoirStudent } from "../devoirStudent/devoirStudent.type";
import { Devoir } from '../devoir/devoir.type';
import { Objectif } from "../objectif/objectif.type";
import { Competence } from "../competence/competence.type";
import { CompetenceStudent } from "../competenceStudent/competenceStudent.type";
import { Matiere } from "../matiere/matiere.type";
import { Observation } from "../observation/observation.type";
import { OptionInvoiceType } from "../../../components/Teacher/SubscriptionTeacher/modals/PackOptionModal";

export enum UserType {
  admin = "admin",
  superAdmin = "superadmin",
  teacher = "teacher",
  school = "school",
  parent = "parent",
  student = "student",
  adult = "adult",
  independentTeacher = "independentTeacher",
}

export type CiviliteType = "homme" | "femme";

export type User = {
  uid: string;
  email: string;
  userName: string;
  fullName: string;
  firstName: string;
  lastName: string;
  phone: string;
  residence: string;
  userType: UserType;
  ninea: string;
  address: string;
  lat: string;
  lng: string;
  acceptConditions: boolean;
  respectConditions: boolean;
  photoURL: string;
  blocked: boolean;
  createdAt: Timestamp;
  isActive: boolean;
  lastLoginDate: string;
  classe?: Class | string | any;
  dateOfBirth?: string;
  genre?: string;
  emailTutor?: string;
  phoneTutor?: string;
  firstNameTutor?: string;
  lastNameTutor?: string;
  photoURLTutor?: string;
  residenceTutor?: string;
  addressTutor?: string;
  userTypeTutor?: UserType;
  latTutor?: string;
  lngTutor?: string;
  parentId?: string;
  teacherId?: string;
  isSendIdentifiant?: boolean;
  classeData?: Class;
  children: User;
  subscriptionStatus: Subscription["status"] | string;
  parent?: User;
  professeur?: User;
  professeurs?: User[];
  archived: boolean;
  archivedAt?: Timestamp;
  enabledMatieres: string[];
  billingDetails: OptionInvoiceType;
  createdBy?: string;
};

export type Student = {
  uid: string;
  studentEmail: string;
  studentUserName: string;
  studentFullName: string;
  studentFirstName: string;
  studentLastName: string;
  studentPhone: string;
  studentResidence: string;
  studentUserType: UserType;
  studentNinea: string;
  studentAddress: string;
  studentLat: string;
  studentLng: string;
  studentAcceptConditions: boolean;
  studentRespectConditions: boolean;
  studentPhotoURL: string;
  studentBlocked: boolean;
  studentCreatedAt: string;
  studentIsActive: boolean;
  studentLastLoginDate: string;
  studentClasse?:  Class | string | any;
  studentTeacherId?: string;
  studentDateOfBirth?: string;
  studentGenre?: string;
  studentIsSendIdentifiant?: boolean;
  studentArchived: boolean;
  studentArchivedAt?: Timestamp;
  parentGenre?: string;
  parentEmail?: string;
  parentPhone?: string;
  parentFirstName?: string;
  parentLastName?: string;
  parentPhotoURL?: string;
  parentResidence?: string;
  parentAddress?: string;
  parentUserType?: UserType;
  parentLat?: string;
  parentLng?: string;
  parentDateOfBirth?: string;
  parentFullName?: string;
  parentIsSendIdentifiant?: boolean;
  createdBy?: string;
  parentArchived: boolean;
  parentArchivedAt?: Timestamp;
  parentId: string;
};

export interface ChildWithSchool {
  infos: User | null;
  school: User | null;
}

export interface AuthState {
  user: User | any;
  token?: string | null;
}
export interface UserSubscription {
  data: Subscription | any;
  loading: boolean,
  error: any,
}


export type UserFormData = Partial<Omit<User, "classeData" >>;

export type StudentFormData = Partial<Student >;


// export interface AuthState {
//   user: IUser | any;
//   token?: string | null;
// }

export type PaginationResults<T> = {
  count?: number;
  next?: string | null;
  previous?: string | null;
  results: T[];
  limit?: number;
  nbPage?: number;
  nbPages?: number;
  nb_contributions?: number;
  total_amount?: number;
  remaning_contributions?: number;
};

export type TypeQuery = Partial<{
  page?: number;
  limit?: number;
  word?: string | null;
  type_mission?: string;
  slug?: string;
  name?: string | null;
  category?: string | null;
  orderBy?: string | null;
  order?: "DESC" | "ASC";
  user?: string;
  search?: string;
  userType?: string;
  q?: string;
  pays?: string;
  type?: string;
  user_type?: string;
  filter?: string;
  q_date?: string;
  q_ville?: string;
  date?: string;
  section?: string;
  period?: string;
  ville?: string;
  non_lus?: string;
  month?: number | null;
  type_facture?: string;
  destinataire_type?: string;
}>;

export type AddressFormData = {
  _id: string;
  prenom: string;
  nom: string;
  adresse: string;
  complementAdresse: string;
  quartier: string;
  ville: string;
  telephone1: string;
  telephone2: string;
  isDefault: boolean;
  latitude: number | string;
  longitude: number | string;
};

type ObjectifStudentWithData = Omit<ObjectifStudent, 'objectifData' | 'professorData'> & {
    objectifData: Objectif | null;
    professorData: User | null;
};

type DevoirStudentWithData = Omit<DevoirStudent, 'devoirData'> & {
    devoirData: Devoir | null;
};

type CompetenceStudentWithData = Omit<CompetenceStudent, 'competenceData' | 'matiereData'> & {
    competenceData: Competence | null;
    matiereData : Matiere | null;
};

export type StudentDashboardStats = {
    matieresCount: number;
    evaluationCount: number;
    devoirsFaitsCount?: number;
    absencesCount: number;
    objectifsDeLaSemaine?: (ObjectifStudentWithData)[];
    objectifsEnCours: (ObjectifStudentWithData)[];
    devoirsAFaire: (DevoirStudentWithData)[];
    competencesGlobal : (CompetenceStudentWithData)[];
    observation: Observation | null;
};

